const ProductionConfig = {
  FRONT_HOST: 'https://2play.game',
  API_HOST: 'https://api.2play.game',
};

export default ProductionConfig;
